import { Field, Input } from '@aigovops/design-system';

export const AUTONOMY_LEVELS = [
  { value: 'human_in_the_loop', label: 'Human-in-the-loop' },
  { value: 'human_on_the_loop', label: 'Human-on-the-loop' },
  { value: 'decision_support', label: 'Decision support' },
  { value: 'informational', label: 'Informational only' },
  { value: 'fully_automated', label: 'Fully automated (no human oversight)' },
];
export const DATA_CLASS_OPTIONS = [
  { value: 'pii', label: 'PII (personally identifiable)' },
  { value: 'phi', label: 'PHI (protected health)' },
  { value: 'financial', label: 'Financial / MNPI' },
  { value: 'proprietary', label: 'Proprietary / trade secret' },
  { value: 'public', label: 'Public data' },
  { value: 'cui', label: 'CUI (controlled unclassified)' },
  { value: 'de_identified', label: 'De-identified / limited data set' },
];
export const AFFECTED_PERSON_OPTIONS = [
  { value: 'employees', label: 'Employees' }, { value: 'consumers', label: 'Consumers / end users' },
  { value: 'patients', label: 'Patients' }, { value: 'students', label: 'Students' },
  { value: 'job_applicants', label: 'Job applicants' }, { value: 'tenants', label: 'Tenants / housing applicants' },
  { value: 'borrowers', label: 'Borrowers / insurance applicants' },
];
export const MARKET_OPTIONS = [
  { value: 'us', label: 'United States' }, { value: 'eu', label: 'European Union' }, { value: 'uk', label: 'United Kingdom' },
  { value: 'ca', label: 'Canada' }, { value: 'global', label: 'Other / worldwide' },
];
export interface SystemIntakeValue {
  name: string; purpose: string; autonomy: string; markets: string[];
  dataClasses: string[]; affectedPersons: string[]; consequential: boolean;
}

/** A checkbox group for one string-array field. */
export function ChoiceList({ legend, options, selected, onChange }: {
  legend: string; options: { value: string; label: string }[]; selected: string[]; onChange: (next: string[]) => void;
}) {
  return <fieldset><legend>{legend}</legend>{options.map(option => <label key={option.value} className="onboarding-choice"><input type="checkbox" checked={selected.includes(option.value)} onChange={e => onChange(e.target.checked ? [...selected, option.value] : selected.filter(v => v !== option.value))} />{option.label}</label>)}</fieldset>;
}

/**
 * V98-3-6: the first-system step asks only for what nothing can derive — the
 * name (pre-filled from the scan) and the main use. Markets, data, people and
 * oversight are confirmed in the "We found" list (FirstSystemIntake).
 */
export function SystemIntakeFields({ value, onChange, locked = false, errors = {} }: {
  value: SystemIntakeValue; onChange: (patch: Partial<SystemIntakeValue>) => void; locked?: boolean;
  errors?: { name?: string; purpose?: string };
}) {
  return <>
    <Field id="system-name" label="System name" required error={errors.name}><Input required disabled={locked} value={value.name} onChange={e => onChange({ name: e.target.value })} /></Field>
    <Field id="system-purpose" label="Main use" hint="What the system does and which decisions it supports." required error={errors.purpose}><Input required value={value.purpose} onChange={e => onChange({ purpose: e.target.value })} /></Field>
  </>;
}
